import clsx from "classnames";
import { TabList } from "@/ui/TabList";
import classes from "./styles.module.scss";
import Image from "@/ui/Image";
import { useLocale } from "@/hooks/useLocale";
import { offerings_helper } from "@/helpers/offerings_helper";
import { cleanMarkup } from "@/functions/cleanMarkup";

export const DiversityPageOfferingsSection = ({ className, pathPrefix }) => {
  const locale = useLocale();
  const items = offerings_helper.fetch();

  return (
    <div className={clsx(className)}>
      <TabList
        title={{ path: `${pathPrefix}.title` }}
        text={{ path: `${pathPrefix}.text` }}
        items={items.map((i, k) => ({
          title: i[`title_${locale}`],
          content: (
            <div key={k} className={clsx(classes.tabs__content, "p-4 p-md-5 me-md-5")}>
              <Image img={i.icon} size="100x100" alt="" className="mb-4" />
              <div className="mx-md-5" dangerouslySetInnerHTML={{ __html: cleanMarkup(i[`text_${locale}`]) }} />
            </div>
          ),
        }))}
        variant="secondary"
      />
    </div>
  );
};

DiversityPageOfferingsSection.defaultProps = {
  className: "py-4 py-md-5",
  pathPrefix: `page.dei.offerings`,
};
